import { Alert } from '@ui-components/neo.tax';
import * as React from 'react';

import { useRdContext } from '@neo.tax/rd/context';

import { CreditCalculationSection } from '../credit-calculation-section';
import { RdLockPageLayout } from '../rd-lock-page-layout';

export const CreditCalculationLayout = (): React.ReactElement => {
  const { isNowPastPeriodEndDate } = useRdContext();

  const isPeriodCurrentAndPartialYearAlert = !isNowPastPeriodEndDate && (
    <Alert
      severity="info"
      title="You're viewing a partial year. This is only an estimate. Please note that changes to projects and allocations will happen automatically when future data is resynced"
    />
  );
  return (
    <RdLockPageLayout
      title="Credit Calculation"
      subtitle="Fill out these questions to calculate your R&D credit."
      pageHeaderBorder
      alert={isPeriodCurrentAndPartialYearAlert}
    >
      <CreditCalculationSection />
    </RdLockPageLayout>
  );
};
